import { render, staticRenderFns } from "./ImportOrdersMobileTable.vue?vue&type=template&id=dcd69a58&scoped=true"
import script from "./ImportOrdersMobileTable.vue?vue&type=script&lang=js"
export * from "./ImportOrdersMobileTable.vue?vue&type=script&lang=js"
import style0 from "./ImportOrdersMobileTable.vue?vue&type=style&index=0&id=dcd69a58&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcd69a58",
  null
  
)

export default component.exports